import {
  LatestSensorData,
  LatestSiteData,
} from 'src/app/shared/interfaces/latest-site-data';

import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

@Component({
  selector: 'app-site-detail-tilt-charts',
  templateUrl: './site-detail-tilt-charts.component.html',
  styleUrls: ['./site-detail-tilt-charts.component.scss'],
})
export class SiteDetailTiltChartsComponent implements OnInit, OnDestroy {
  @Input() latestSiteData: LatestSiteData | null = null;
  sensorData: LatestSensorData = {};

  chartRange: string = '';

  daytimeButtonDisabled = false;
  dayButtonDisabled = false;
  weekButtonDisabled = false;
  monthButtonDisabled = false;

  ngOnInit(): void {
    if (
      this.latestSiteData !== null &&
      this.latestSiteData.sensorData !== undefined
    ) {
      this.sensorData = this.latestSiteData.sensorData;
    }

    this.onClickDaytimeCharts();
  }
  ngOnDestroy(): void {}

  disableAllChartsButton() {
    this.daytimeButtonDisabled = false;
    this.dayButtonDisabled = false;
    this.weekButtonDisabled = false;
    this.monthButtonDisabled = false;
  }

  onClickDaytimeCharts() {
    this.disableAllChartsButton();
    this.daytimeButtonDisabled = true;
    this.chartRange = 'daytime';
  }

  onClick1DayCharts() {
    this.disableAllChartsButton();
    this.dayButtonDisabled = true;
    this.chartRange = 'day';
  }

  onClick1WeekCharts() {
    this.disableAllChartsButton();
    this.weekButtonDisabled = true;
    this.chartRange = 'week';
  }

  onClick1MonthCharts() {
    this.disableAllChartsButton();
    this.monthButtonDisabled = true;
    this.chartRange = 'month';
  }
}
